import Footer from "./Footer";
import {Image} from "react-bootstrap";
import './StudentsGallery.css';

let StudentsGallery2024 = () => {
    const verticalImageList = [
        "img1.jpeg",
        "img2.jpeg",
        "img3.jpeg",
        "img4.jpeg",
        "img5.jpeg",
        "img7.jpeg",
        "img8.jpeg",
        "img10.jpeg",
        "img12.jpeg",
        "img15.jpeg",
        "img16.jpeg",
        "img19.jpeg",
        "img21.jpeg",
        "img22.jpeg",
        "img23.jpeg",
        "img24.jpeg",
        "img30.jpeg",
        "img31.jpeg",
        "img32.jpeg",
        "img34.jpeg",
        "img35.jpeg",
        "img36.jpeg",
        "img37.jpeg",
        "img40.jpeg",
        "img41.jpeg",
        "img43.jpeg",
        "img46.jpeg",
        "img47.jpeg",
        "img51.jpeg",
        "img53.jpeg",
        "img56.jpeg",
        "img56_1.jpeg",
        "img57.jpeg",
        "img58.jpeg",
        "img59.jpeg",
        "img61.jpeg",
        "img62.jpeg",
        "img65.jpeg",
        "img67.jpeg",
        "img68.jpeg",
        "img70.jpeg",
        "img71.jpeg",
        "img72.jpeg",
        "img73.jpeg",
        "img74.jpeg",
        "img75.jpeg",
        "img76.jpeg",
        "img77.jpeg",
        "img80.jpeg",
        "img82.jpeg",
        "img83.jpeg",
        "img84.jpeg",
        "img85.jpeg",
        "img86.jpeg",
        "img87.jpeg",
        "img88.jpeg",
        "img89.jpeg",
        "img90.jpeg",
        "img92.jpeg",
        "img93.jpeg",
        "img94.jpeg",
        "img99.jpeg",
        "img100.jpeg",
        "img103.jpeg",
        "img104.jpeg",
        "img105.jpeg",
        "img107.jpeg",
        "img117.jpeg",
        "img118.jpeg",
        "img119.jpeg",
        "img120.jpeg",
        "img121.jpeg",
        "img122.jpeg",
        "img123.jpeg",
        "img124.jpeg",
        "img126.jpeg",
        "img139.jpeg",
        "img140.jpeg"
    ]

    const horizontalImageList = [
        "img6.jpeg",
        "img9.jpeg",
        "img11.jpeg",
        "img13.jpeg",
        "img14.jpeg",
        "img17.jpeg",
        "img18.jpeg",
        "img20.jpeg",
        "img25.jpeg",
        "img26.jpeg",
        "img27.jpeg",
        "img28.jpeg",
        "img29.jpeg",
        "img33.jpeg",
        "img38.jpeg",
        "img39.jpeg",
        "img42.jpeg",
        "img44.jpeg",
        "img45.jpeg",
        "img48.jpeg",
        "img49.jpeg",
        "img50.jpeg",
        "img52.jpeg",
        "img54.jpeg",
        "img55.jpeg",
        "img60.jpeg",
        "img63.jpeg",
        "img64.jpeg",
        "img66.jpeg",
        "img69.jpeg",
        "img78.jpeg",
        "img79.jpeg",
        "img81.jpeg",
        "img91.jpeg",
        "img95.jpeg",
        "img96.jpeg",
        "img97.jpeg",
        "img98.jpeg",
        "img101.jpeg",
        "img102.jpeg",
        "img106.jpeg",
        "img108.jpeg",
        "img109.jpeg",
        "img110.jpeg",
        "img111.jpeg",
        "img112.jpeg",
        "img113.jpeg",
        "img114.jpeg",
        "img115.jpeg",
        "img116.jpeg",
        "img125.jpeg",
        "img127.jpeg",
        "img128.jpeg",
        "img129.jpeg",
        "img130.jpeg",
        "img131.jpeg",
        "img132.jpeg",
        "img133.jpeg",
        "img134.jpeg",
        "img135.jpeg",
        "img136.jpeg",
        "img137.jpeg",
        "img138.jpeg"  
    ]

    return(
        <div className="content text-center">
            <div>
                {verticalImageList.map(path => <Image className="imageVertical m-3" src={require("./img/galeria-uczniowie/" + path)} rounded />)}
            </div>
            <div>
                {horizontalImageList.map(path => <Image className="imageHorizontal m-3" src={require("./img/galeria-uczniowie/" + path)} rounded />)}
            </div>

        </div>
    )
}

export default StudentsGallery2024;